<template>
  <div class="text-xs-center">
    <v-bottom-sheet v-model="sheet">
      <template v-slot:activator>
        <button class="fas fa-bolt" title="Quick Navigation" />
      </template>
      <v-card height="calc(50vh)">
        <v-text-field
          append-icon="fab fa-searchengin"
          label="Quick Navigation"
          autofocus
          v-if="sheet"
          v-model="searchTerm"
          @keyup.enter="goFirstResult"
        />
        <navigation :external-items="filtered" />
      </v-card>
    </v-bottom-sheet>
  </div>
</template>

<script>
import {mapGetters} from 'vuex'
import Navigation from './Navigation'
import fuzzysort from 'fuzzysort'

export default {
  mounted() {
    window.addEventListener('keypress', this.handleKey)
    window.addEventListener('keydown', this.handleKey)
  },
  beforeDestroy() {
    window.removeEventListener('keypress', this.handleKey)
    window.removeEventListener('keydown', this.handleKey)
  },
  data() {
    return {
      sheet: false,
      searchTerm: '',
    }
  },
  methods: {
    handleKey(event) {
      const ctrlKey = navigator.platform.indexOf('Mac') > -1 ? event.metaKey : event.ctrlKey
      if (ctrlKey && event.key === 'f') {
        this.sheet = true
        event.preventDefault()
      }
    },
    goFirstResult() {
      const [firstResult] = this.filtered
      if (firstResult.to != this.$route.path) {
        this.$router.push(firstResult.to)
      }
    },
  },
  computed: {
    ...mapGetters({filteredItems: 'app/filteredItems'}),
    ...mapGetters({history: 'app/history'}),
    flatItems() {
      return this.filteredItems
        .filter(item => item.children)
        .map(parent =>
          [...parent.children].map(child => ({
            ...child,
            text: `${parent.text} ${child.text}`,
            searchText: `${child.module} ${parent.text} ${child.text}`,
          })),
        )
        .flat()
        .filter(item => item.to != this.$route.path)
    },
    filtered() {
      if (this.searchTerm === '') {
        const byKey = this.flatItems
          .map(item => item)
          .reduce((acc, item) => {
            acc[item.to] = item
            return acc
          }, {})
        return this.history.map(path => byKey[path]).filter(Boolean)
      }

      return fuzzysort.go(this.searchTerm, this.flatItems, {key: 'searchText'}).map(o => o.obj)
    },
  },
  components: {
    Navigation,
  },
  watch: {
    sheet(newValue) {
      if (!newValue) {
        this.searchTerm = ''
      }
    },
    $route() {
      this.sheet = false
    },
  },
}
</script>
<style scoped>
button {
  width: 20px;
  height: 20px;
}
</style>
